// extracted by mini-css-extract-plugin
export default {"exceptionSection":"exceptionSection---Upkbd","exceptionAddButton":"exceptionAddButton---JYE09"};